export default __webpack_public_path__ + "static/media/screenShots_astramed-3.a9119aac.jpg";